import React, { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { adminMockApi } from "../../../api/adminMockApi";
import api from "../../../api/axios";

export default function SubscriptionsPage() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [search, setSearch] = useState("");
  const [plan, setPlan] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSubscription();
  }, []);


  const loadSubscription = async () => {
    try {
      setLoading(true);

      const response = await api.get("/subscription/list");
      console.log(response.data, "response.data")
      if (response && response.data && response.data.success) {
        setSubscriptions(response.data?.data?.list || []);
         setLoading(false);
      } else {
        setLoading(false);
        setSubscriptions([]);
      }
    } catch (err) {
      setLoading(false);
      console.log(err?.data?.message);
    }
  };

  const rows = useMemo(() => {
    return subscriptions.filter((item) => {
      const matchesSearch =
        (item.sub_org_name || item.sub_org_id || "")
          .toLowerCase()
          .includes(search.toLowerCase());

      const matchesPlan =
        !plan || item.sub_plan === plan;

      return matchesSearch && matchesPlan;
    });
  }, [subscriptions, search, plan]);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Subscriptions</h2>
        <p className="mt-1 text-sm text-slate-500">
          Review billing cycles, usage, and subscription health.
        </p>
      </div>
      <section className="rounded-xl border border-slate-200 bg-white shadow-sm">
        <div className="flex gap-3 border-b p-4">
          <label className="relative flex-1">
            <Search
              size={17}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
            />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search organizations…"
              className="w-full rounded-lg border px-9 py-2 text-sm"
            />
          </label>
          <select
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
            className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
          >
            <option value="">All Plans</option>

            {[...new Set(subscriptions.map((x) => x.sub_plan))].map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1100px] text-left text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
              <tr>
                <th className="px-5 py-3">Organization</th>
                <th className="px-5 py-3">Plan</th>
                <th className="px-5 py-3">Status</th>
                <th className="px-5 py-3">Users</th>
                <th className="px-5 py-3">Creatives</th>
                <th className="px-5 py-3">Campaigns</th>
                <th className="px-5 py-3">Brands</th>
                <th className="px-5 py-3">Templates</th>
                <th className="px-5 py-3">Start Date</th>
                <th className="px-5 py-3">Created</th>
                <th className="px-5 py-3">Updated</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100 bg-white">

              {loading && (
                <tr>
                  <td colSpan={11} className="py-10 text-center text-slate-500">
                    Loading subscriptions...
                  </td>
                </tr>
              )}

              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={11} className="py-10 text-center text-slate-500">
                    No subscriptions found.
                  </td>
                </tr>
              )}

              {!loading &&
                rows.map((item) => (
                  <tr key={item.sub_id} className="hover:bg-slate-50">

                    {/* Organization */}
                    <td className="px-5 py-4">
                      <div className="font-semibold">
                        {item.org_name || "-"}
                      </div>

                      <div className="text-xs text-slate-500">
                        {item.sub_org_id}
                      </div>
                    </td>

                    {/* Plan */}
                    <td className="px-5 py-4">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-semibold ${item.sub_plan === "FREE"
                            ? "bg-green-100 text-green-700"
                            : item.sub_plan === "PRO"
                              ? "bg-indigo-100 text-indigo-700"
                              : item.sub_plan === "ENTERPRISE"
                                ? "bg-purple-100 text-purple-700"
                                : "bg-slate-100 text-slate-700"
                          }`}
                      >
                        {item.sub_plan}
                      </span>
                    </td>

                    {/* Status */}
                    <td className="px-5 py-4">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-semibold ${item.sub_status === "ACTIVE"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                          }`}
                      >
                        {item.sub_status}
                      </span>
                    </td>

                    {/* Limits */}
                    <td className="px-5 py-4">{item.sub_limits?.users ?? "-"}</td>
                    <td className="px-5 py-4">{item.sub_limits?.creatives ?? "-"}</td>
                    <td className="px-5 py-4">{item.sub_limits?.campaigns ?? "-"}</td>
                    <td className="px-5 py-4">{item.sub_limits?.brands ?? "-"}</td>
                    <td className="px-5 py-4">{item.sub_limits?.templates ?? "-"}</td>

                    {/* Start */}
                    <td className="px-5 py-4">
                      {new Date(item.sub_start_date).toLocaleDateString()}
                    </td>

                    {/* Created */}
                    <td className="px-5 py-4">
                      <div>
                        {new Date(item.sub_created_on).toLocaleDateString()}
                      </div>
                      <div className="text-xs text-slate-400">
                        {new Date(item.sub_created_on).toLocaleTimeString()}
                      </div>
                    </td>

                    {/* Updated */}
                    <td className="px-5 py-4">
                      <div>
                        {new Date(item.sub_updated_on).toLocaleDateString()}
                      </div>
                      <div className="text-xs text-slate-400">
                        {new Date(item.sub_updated_on).toLocaleTimeString()}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
